import React, { useCallback, useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import Switch from "react-switch";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

// img
import p1 from "../../../../../Assets/images/user.png";
import formIcn from "../../../../../Assets/images/formIcn.svg";
import form from "../../../../../Assets/images/form.png";

// files
import AssignDisciplinePop from "../../../../../components/Modals/AssignDisciplinePop";
import { homeEducationApi, useArchiveHomeEducationClientMutation, useDeleteIntakeMutation, useFavouriteEducationfClientMutation, useGetHomeEducationClientDetailsQuery, useSendIntakeMutation, useUpdateHomeEducationClientMutation } from "store/services/clients/homeEducation.client";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { CLIENT_ATTENDANCE_LIST, CLIENT_DOCUMENTS_LIST, CLIENT_SERVICE_STATUS_LIST, CLINICIANS_HISTORY, EDIT_HOME_EDUCATION, HOME_EDUCATION_CREATE_INTAKE_REPORT, HOME_EDUCATION_CREATE_INTAKE_REPORT_V2, HOME_EDUCATION_LIST } from "config/paths";
import { useAssignTherapistMutation, useChangeTherapistMutation, useCreateNewCaseloadMutation, useGetClientCaseloadsListQuery, useRemoveTherapistAssignmentMutation, useRemoveTherapistMutation, useUpdateCaseloadStatusMutation, useUpdateMdtStatusMutation, useUpdateTherapistServiceStatusMutation } from "store/services/clientCaseLoads";
import { convertToMomentDate, dateFormat, dateFormatLocal, formatString, getAge, promiseToast, successMessageToast, userFullName } from "helpers/common";
import { CASE_STATUSES, CLIENT_STATUS_OPTION, CLIENT_TYPE_KEYS, HOME_CLIENT_STATUS_OPTION, NO_HISTORY_FOUND } from "config/constants";
import IconButton from "components/shared/Buttons/IconButton";
import { CloseIcon, DeleteIcon, ViewDocumentIcon } from "Assets/icons";
import { useDispatch } from "react-redux";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import moment from "moment";
import { useGetNoteQuery } from "store/services/note";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import AddDocumentPop from "components/Modals/AddDocumentPop";
import { mdtAssessmentApi } from "store/services/MDT/assessment";
import Attachments from "components/shared/Attachments";
import TrackAttendance from "components/shared/TrackAttendance";
import GuardianDetailList from "components/shared/GuardianDetailList";
import { debounce, filter, find } from "lodash";
import { useFileViewer } from "hooks/useFileViewer";
import SendIntakePop from "components/Modals/SendIntakeReportPop";
import ChangeTherapistPop from "components/Modals/ChangeTherapistPop";
import { Breadcrumbs, CommonSelect, CommonToolTip, CstmPagination, NoRecordFound } from "components/Common/Common";
import confirmDialog from "utils/confirmationDialog";
import { useClientsServiceStatusListQuery } from "store/services/utility";
import ManageAppointmentBalance from "../../Components/ManageAppointmentBalance";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { Star } from "react-feather";
import NotesComponentV2 from "pages/SideTabPages/Notes/NotesComponentV2";
import SeeMore from "components/SeeMore";
import AddPlus from "Assets/images/AddPlus";
import CliniciansAssignedComponent from "components/shared/FormComponents/V2/CliniciansAssigned/CliniciansAssignedComponent";
import AssignDisciplineModal from "components/Modals/AssignDisciplinesModal";
import ClientAttachments from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachments";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import ReportsComponent from "components/shared/FormComponents/V2/ReportsComponent/ReportsComponent";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useLazyUpdateClientStatusQuery } from "store/services/client";
import ClientExpiryModal from "components/Modals/ClientExpiryModal";

const ClientHomeDetail = () => {

  const dispatch = useDispatch();
  const { id: clientId } = useParams();
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null)
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [sendIntakeModal, setSendIntakeModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(null)
  const [changeTherapistId, setChangeTherapistId] = useState(null)
  const [showDischargeModal, setShowDischargeModal] = useState(false)
  const [modalType, setModalType] = useState(null)
  const [hasActiveTherapist, setHasActiveTherapist] = useState(false)
  const pageSize = 10
  const [currentPage, setCurrentPage] = useState(1)
  const [filterHistory, setFilterHistory] = useState({ search: "" })
  const [clientExpiryModal, setClientExpiryModal] = useState(false)


  const [isDisabled, setIsDisabled] = useState(false)
  const [assignDisciplineModal, setAssignDisciplineModal] = useState(false)
  const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
  const clientType = CLIENT_TYPE_KEYS.home_education
  const [clientStatus, setClientStatus] = useState(null)


  // file viewer hook
  const { handleViewPdf, getFileLoading } = useFileViewer();

  // client details
  const { data: clientDetails, isLoading, refetch, isFetching } = useGetHomeEducationClientDetailsQuery(clientId);
  const intakeForms = filter(clientDetails?.clientResources, resource => resource.module === `home_education_intake_form_${clientId}`);
  const attachments = filter(clientDetails?.clientResources, resource => resource.module !== `home_education_intake_form_${clientId}`);
  const mdtCaseload = clientDetails?.clientCaseloads?.find(x => x.case_type == "mdt");
  const caseloadPending = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular" && x.case_status == "pending") || null;
  const caseloadTherapist = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.clientCaseloadTherapist || [];
  const caseLoadId = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.id;
  const assignedTherapist = caseloadTherapist?.filter(x => x.status != 65);
  const [updateTherpaistServiceStatus, { isLoading: updateTherpaistServiceStatusLoading }] = useUpdateTherapistServiceStatusMutation()
  const [updateCaseloadStatus, { isLoading: updateCaseloadStatusLoading }] = useUpdateCaseloadStatusMutation()
  const [createNewCaseload, { isLoading: newCreateCaseloadLoading }] = useCreateNewCaseloadMutation()

  //  Service status lookup
  const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: "home_education" });
  const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }));
  const { data: caseLoadsList, isFetching: caseLoadsListFetching } = useGetClientCaseloadsListQuery({ id: clientId, page: currentPage, limit: pageSize, ...filterHistory })
  const totalRecords = caseLoadsList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize)
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteEducationfClientMutation()

  const [assignTherapist, { isLoading: assignTherapistLoading }] = useAssignTherapistMutation();
  const [removeTherapist, { isLoading: removeTherapistLoading }] = useRemoveTherapistMutation();
  const [updateMdtStatus, { isLoading: updateMdtLoading }] = useUpdateMdtStatusMutation();
  const [archiveClient, { isLoading: archiveClientLoading }] = useArchiveHomeEducationClientMutation();
  const [changeTherapist, { isLoading: changeTherapistLoading }] = useChangeTherapistMutation();
  const [updateStatus, { isFetching: updateStatusLoading }] = useLazyUpdateClientStatusQuery()

  const { data: noteDetails } = useGetNoteQuery({ clientId, moduleName: "clients-home-education" });
  const note = noteDetails?.[0];

  const [updateClient, { isLoading: updateSchoolLoading }] = useUpdateHomeEducationClientMutation();

  // send intake
  const [sendIntake, { isLoading: sendIntakeLoading }] = useSendIntakeMutation();
  const [deleteIntake, { isLoading: deleteIntakeLoading }] = useDeleteIntakeMutation();

  const [checked, setChecked] = useState(false);
  const [showAssignDisciplinePopup, setShowAssignDisciplinePopup] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const handleChange = (checked) => {
    setShowConfirmationModal(true);
  };
  const toggleDisciplinePopup = () => setShowAssignDisciplinePopup(!showAssignDisciplinePopup);

  const handleArchive = async () => {
    try {

      setShowModal(false);

      const result = await archiveClient(clientId);
      if (!result?.error) successMessageToast("Record has been updated successfully.");

    } catch (err) {
      console.error("error archiving home education", err);
    };
  };

  const handleAssignTherapist = async (values) => {
    try {
      let payload = {
        caseload_id: values?.caseload_id,
        discipline_id: values?.discipline_id?.value,
        therapist_id: values?.therapist_id?.value,
      }
      let { data, error } = await assignTherapist(payload);
      if (error) {
        return;
      }

      successMessageToast(data?.message);
      setShowAssignDisciplinePopup(false);
      refetch();
    } catch (err) {
      console.error("Error assigning therapist", err);
    }
  };

  const handleRemoveTherapist = async () => {
    try {

      setShowRemoveModal(false);
      let { data, error } = await removeTherapist(currentEntry?.id);
      if (error) {
        return;
      }

      successMessageToast(data?.message);
      refetch();
    } catch (err) {
      console.error("Error removing Therapist assignment", err);
    }
  };

  const handleUpdateMdtStatus = async (values) => {
    try {

      setShowConfirmationModal(false);
      let result = await updateMdtStatus({ id: clientId, type: !checked ? "mdt" : "regular" });
      if (result?.error) return;

      refetch();
      setChecked(!checked);
      successMessageToast(result?.message);
      dispatch(homeEducationApi.util.invalidateTags(['HomeEducationList']));
      dispatch(mdtAssessmentApi.util.invalidateTags(['mdtAssessmentList']));
      successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("Error updating mdt status", err);
    }
  };

  const uploadDocuments = async (payload) => {
    try {

      setShowDocumentModal(false);

      const values = {
        documents: payload.documents,
        firstname: clientDetails?.firstname,
        lastname: clientDetails?.lastname,
        dob: clientDetails?.client_detail?.dob,
        gender: clientDetails?.client_detail?.gender,
        grade: clientDetails?.client_detail?.grade,
        city_town: clientDetails?.client_detail?.city_town,
        parents: [],
        status: clientDetails?.status,
      };

      const result = await updateClient({ clientId, data: values, });

      if (result?.error) {
        console.error("Error creating School Client", result.error);
      } else {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.error("Error adding document", err);
    }
  };

  const handleSendIntake = async (values) => {
    try {

      setSendIntakeModal(false);
      const result = await sendIntake({ clientId, email: values?.email });
      if (result?.error) return;

      successMessageToast(result?.data?.message);
    } catch (err) {
      console.error("Error sending intake", err);
    }
  };

  const handleDeleteIntake = async (values) => {
    try {

      setShowDeleteModal(false);
      const result = await deleteIntake({ clientId, intakeId: currentEntry?.id });
      if (result?.error) return;

      refetch();
      successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("Error deletng intake report", err);
    }
  };


  const handleChangeTherapist = async (values) => {
    try {
      let { data, error } = await changeTherapist({ assignmentId: currentEntry?.id, therapistId: values?.therapist_id?.value });
      if (error) {
        return;
      }
      refetch();
      setShowChangeModal(false);
      successMessageToast(data?.message);
    } catch (err) {
      console.error("Error change Therapist", err);
    }
  }

  const handleUpdateClient = (field) => async (value) => {
    try {
      let confirm = await confirmDialog({ type: "update" });
      if (!confirm) {
        return;
      }

      const data = {
        [field]: value
      }
      await updateClient({ clientId, data }).unwrap();
    } catch (err) {
      console.error("Error updating client", err);
    }
  }

  const handleServiceStatus = async (id, therapistId) => {
    const payload = {
      service_status: id
    }
    try {
      await updateTherpaistServiceStatus({ payload, id: therapistId }).unwrap()
      refetch()
    } catch (error) {
      console.log("Error updating service status: ", error)
    }
  }

  const handleCaseloadDischarge = async () => {
    setShowDischargeModal(false)
    const payload = {
      case_status: "complete"
    }
    try {
      const result = await updateCaseloadStatus({ payload, id: caseloadPending?.id }).unwrap()
      successMessageToast(result?.message)
      refetch()
    } catch (error) {
      console.log("error discharging: ", error)
    }
  }

  const handleCreateCaseLoad = async () => {
    setShowDischargeModal(false)
    try {
      const result = await createNewCaseload({ id: clientId }).unwrap()
      refetch()
      successMessageToast(result?.message)
      setModalType(null)
      toggleDisciplinePopup()
    } catch (error) {
      console.log("error creating new caseload: ", error)
    }
  }

  const resetFilter = () => {
    setFilterHistory({ search: "" })
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    setFilterHistory({ ...filterHistory, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };

  useEffect(() => {
    // setChecked(mdtCaseload && mdtCaseload?.mdt_status != 63 ? true : false)
    setChecked(mdtCaseload)
  }, [mdtCaseload]);

  useEffect(() => {
    const result = assignedTherapist?.some(
      (assignment) => assignment?.caseServiceStatus?.title?.toLowerCase() !== 'discharge'
    );
    setHasActiveTherapist(result || false); // fallback to false if result is undefined
  }, [assignedTherapist]);

  const breadcrumbItems = [
    { label: "Home Education", path: '/client/home-education' },
    { label: userFullName(clientDetails) || "Client Details" },
  ];

  useEffect(() => {
    if (clientDetails?.status == "discharged" || clientDetails?.status == "inactive") {
      setIsDisabled(true);
    }
    if (clientDetails?.status) {
      setClientStatus({ label: formatString(clientDetails?.status), value: clientDetails?.status })
    }
  }, [clientDetails])

  const handleUpdateStatus = async (e, status) => {
    // e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "STATUS CHANGE ?",
      message: `Are you sure you want to change the client status to ${status?.label} ?`,
    });
    if (!isConfirm) {
      return;
    }
    try {
      await updateStatus({ clientId, clientType, status: status?.value }).unwrap();
      refetch()
      // navigate(generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }))
    } catch (error) {
      console.log('error', error)
    }
  }


  const handleFavouriteClient = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      const response = await favouriteClient({ data, id }).unwrap()
      // refetch();
      successMessageToast(response?.message)
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }



  return (
    <>
      <ClientExpiryModal
        show={clientExpiryModal}
        setShow={setClientExpiryModal}
        refetch={refetch}
        clientDetails={clientDetails}
        clientType={clientType}
        clientId={clientId}
        caseLoadId={clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.clientCaseloadTherapist?.[0]?.id}
      />
      <ChangeTherapistPop
        showPopup={showChangeModal}
        setShowPopup={setShowChangeModal}
        discipline={currentEntry?.discipline_id}
        currentTherapist={currentEntry?.id}
        handleSubmit={handleChangeTherapist}
        isLoading={changeTherapistLoading}
        therapistId={currentEntry?.therapist_id}
      />
      <SendIntakePop
        show={sendIntakeModal}
        setShow={setSendIntakeModal}
        submitHandler={handleSendIntake}
        heading="Send Intake Form"
      />
      <ConfirmationPop
        confirmation={showDeleteModal}
        setConfirmation={setShowDeleteModal}
        confirmHandler={handleDeleteIntake}
        type="delete"
      />

      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleArchive}
        type={clientDetails?.status == "active" ? "archive" : "active"}
      />

      <AddDocumentPop
        show={showDocumentModal}
        setShow={setShowDocumentModal}
        handleSubmit={uploadDocuments}
      />

      {updateSchoolLoading && <LoadingOverlay />}

      <ConfirmationPop
        confirmation={showConfirmationModal}
        setConfirmation={setShowConfirmationModal}
        confirmHandler={handleUpdateMdtStatus}
        type="update"
      />

      <ConfirmationPop
        confirmation={showRemoveModal}
        setConfirmation={setShowRemoveModal}
        confirmHandler={handleRemoveTherapist}
        type="remove"
      />

      <ConfirmationPop
        confirmation={showDischargeModal}
        setConfirmation={setShowDischargeModal}
        confirmHandler={modalType ? handleCreateCaseLoad : handleCaseloadDischarge}
        type={modalType ? modalType : "caseloadDischarge"}
      />

      <AssignDisciplinePop
        showPopup={showAssignDisciplinePopup}
        setShowPopup={setShowAssignDisciplinePopup}
        caseLoadId={caseloadPending?.id}
        handleSubmit={handleAssignTherapist}
        isLoading={assignTherapistLoading}
      />
      <AssignDisciplineModal
        show={assignDisciplineModal}
        setShow={setAssignDisciplineModal}
        caseLoadId={caseloadPending?.id}
        clientDetails={clientDetails}
        refetch={refetch}
      />

      <AddClientDocumentsModal
        show={clientsDocumentModal}
        setShow={setClientsDocumentModal}
        clientId={clientId}
        refetch={refetch}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <Row>
                {(isFetching || caseLoadsListFetching || updateCaseloadStatusLoading || newCreateCaseloadLoading || updateTherpaistServiceStatusLoading || updateMdtLoading || getFileLoading || removeTherapistLoading || archiveClientLoading || deleteIntakeLoading || sendIntakeLoading) && (
                  <LoadingOverlay />
                )}
                <Row className="pt-3">
                  <Col lg="7">
                    <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                  </Col>
                  <Col lg="5">

                  </Col>
                </Row>


                <div style={{ marginTop: clientDetails?.status == 'active' ? "-10px" : '20px' }}>
                  <p>
                    <div className="d-flex align-items-end gap-2 proxima-regular">
                      <div className="cursor-pointer" onClick={() => { !favouriteClientLoading && handleFavouriteClient(clientDetails?.client_detail?.id, clientDetails?.client_detail?.is_favorite ? 0 : 1) }}>{clientDetails?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" /> : <Star />}
                      </div>
                      <Row className="w-100 align-items-end">
                        <Col lg='7'>
                          <div className="d-flex gap-3 align-items-end">
                            <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000", fontSize: "20px" }}>
                              {clientDetails?.status != 'active' && <div className="text-capitalize">{`${clientDetails?.status}:`}</div>}{" "}{userFullName(clientDetails)}

                              <span onClick={() => navigate(generatePath(CLIENT_SERVICE_STATUS_LIST, { clientId, clientType: 'home-education' }))} className="themeBlueV2 cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SERVICE STATUS</span>
                            </p>
                            <div style={{ width: "25%" }} className="reports-v2 classroom-conslutation">
                              <div className="w-100 align-items-center gap-3">
                                {/* <label className="discharge-screen-label mb-0">School</label> */}
                                <CommonSelect
                                  placeholder={"Choose one..."}
                                  option={HOME_CLIENT_STATUS_OPTION?.filter((item) => item?.value)}
                                  onChange={(e) => handleUpdateStatus(e, e)}
                                  value={clientStatus}
                                  // onInputChange={(val) => handleSearch(val)}
                                  isFilterV2
                                  // isClearable
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                    }),
                                  }}
                                // isLoading={schoolsLoading}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg='5'>
                          <div className="d-flex align-items-end justify-content-end gap-3">
                            <div onClick={() => navigate(generatePath(CLIENT_ATTENDANCE_LIST, { clientId, clientType: 'home-education' }))} className="text-end">
                              <span className="themeBlueV2 cursor-pointer ten ms-2 fw-medium fs-8" style={{ textDecoration: "underline", marginTop: clientDetails?.status != 'active' && "10px" }}>SEE ATTENDANCE DETAILS</span>
                            </div>
                            <div style={{ display: "flex", gap: "10px" }}>
                              {
                                <div className="cursor-pointer mb-2" onClick={() => setClientExpiryModal(true)} style={{ marginLeft: "auto", width: "236px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                                  <Row className="mb-1">
                                    <Col lg='6'>
                                      <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                                    </Col>
                                    <Col lg='6'>
                                      <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE OF EXPIRY</h3>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg='6'>
                                      <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: clientDetails?.status == 'active' && "#55A215", fontStyle: ["archived", "discharged"]?.includes(clientDetails?.status) && "italic" }}>{clientDetails?.status}</h2>
                                    </Col>
                                    <Col lg='6'>
                                      <h2 className="black mb-0 forteen  text-start">{clientDetails?.client_detail?.date_of_expiry ? dateFormat(clientDetails?.client_detail?.date_of_expiry, "MMM DD, YYYY") : "--"}</h2>
                                    </Col>
                                  </Row>
                                </div>
                              }
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </p>
                </div>

                <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="d-flex justify-content-between">
                        <div style={{ display: "inline-flex" }} className="date-title justify-content-between">
                          <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px" }}>CLIENT INFORMATION</h6>
                          <div className="d-flex align-items-center gap-2">
                            {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(clientDetails?.record?.reportsPreflightTeacher)}</p>
                          </div>
                        </div>
                        {/* <SeeMore title='SEE MORE' /> */}
                      </div>
                      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE OF BIRTH</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>GENDER</h5>
                            <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>CITY/TOWN</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-4">
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>GRADE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>AGE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      {
                        clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => index <= 1 && <>
                          <div className="date-title d-flex justify-content-between pt-3">
                            <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000" }}>{`PARENT ${index + 1}`}</h6>
                          </div>
                          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-5">
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                              </div>
                            </div>
                          </div>
                        </>)
                      }
                    </div>
                  </div>

                </div>

                <div>
                  <Row className="pt-4">
                    <Col lg="6">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <NotesComponentV2
                          client_id={clientId}
                          module={"clients-home-education"}
                          v2={true}
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <Col md="12" sm="6" className="mb-2">
                        <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                          <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>MDT Assessment
                            {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                          </h6>
                          <div className="content d-flex align-items-center">
                            <p className="m-0 forteen text-muted mx-1">Off</p>
                            <Switch
                              uncheckedIcon={""}
                              checkedIcon={""}
                              onHandleColor={"#315D99"}
                              offHandleColor={"#315D99"}
                              onColor={"#E6E6E6"}
                              offColor={"#E6E6E6"}
                              height={18}
                              width={40}
                              onChange={handleChange}
                              checked={checked}
                              disabled={updateMdtLoading || isDisabled}
                            />
                            <p className="m-0 forteen text-muted mx-1">On</p>
                          </div>
                        </div>
                      </Col>
                      <Col md="12" sm="6" className="mb-2">
                        <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                          <Row>
                            <Col lg="8">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>Intake Form</h6>
                            </Col>
                            <Col lg='4' className="text-end">
                              <AddPlus isDisabled={isDisabled} onClick={() => navigate(generatePath(HOME_EDUCATION_CREATE_INTAKE_REPORT_V2, { id: clientId })
                              )} />
                            </Col>
                          </Row>
                          <Row>
                            {intakeForms?.length > 0 && intakeForms.map((intake, index) => {
                              return (
                                <Col key={index} lg="3" md="4" sm="6" className="my-2">
                                  <div className="cardCstm parents-detail-wrapper bg-white shadow position-relative px-1 py-1" style={{ borderRadius: "11px" }}>
                                    <img
                                      src={form}
                                      alt=""
                                      className="img-fluid object-fit-contain rounded"
                                    />
                                    <div
                                      className="content position-absolute h-100 w-100 d-flex align-items-center justify-content-center flex-column gap-10 px-3"
                                      style={{ top: 0, left: -0 }}
                                    >
                                      <CloseIcon
                                        style={{ top: "6px", right: "6px", opacity: "0.5", height: "8px", width: "8px", cursor: "pointer" }}
                                        className="position-absolute"
                                        onClick={() => {
                                          setCurrentEntry(intake);
                                          setShowDeleteModal(true);
                                        }}
                                      />
                                      <IconButton
                                        onClick={() => {
                                          handleViewPdf(intake?.attachment_name);
                                        }}
                                      >
                                        <span className="icn">
                                          <ViewDocumentIcon />
                                        </span>
                                      </IconButton>

                                    </div>
                                  </div>
                                </Col>
                              )
                            })}
                          </Row>
                        </div>

                      </Col>

                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>CLINICIANS
                                {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                              </h6>
                              <SeeMore onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType:"home-education"  }))} title='HISTORY' />
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            <AddPlus isDisabled={isDisabled} onClick={() => !isDisabled && setAssignDisciplineModal(true)} />
                          </Col>
                        </Row>
                        <CliniciansAssignedComponent refetch={refetch} isDisabled={isDisabled} onClick={() => clientDetails?.status != "discharged" && setAssignDisciplineModal(true)} clientDetails={clientDetails} setCurrentEntry={setCurrentEntry} setShowDeleteModal={setShowDeleteModal} />
                      </div>
                      <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 onClick={() => navigate(generatePath(CLIENT_DOCUMENTS_LIST, { clientId, clientType: "home-education" }))} className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>DOCUMENTS
                                {/* <span className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span> */}
                              </h6>
                              <SeeMore onClick={() => navigate(generatePath(CLIENT_DOCUMENTS_LIST, { clientId, clientType: "home-education" }))} title='SHOW ALL' />
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            <AddPlus isDisabled={isDisabled} onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)} />
                          </Col>
                        </Row>
                        <ClientAttachments
                          isPage={false}
                          resources={clientDetails?.clientResources || []}
                          clientId={clientId}
                          refetch={refetch}
                          clientType={clientType}
                          limit={4}
                          onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)}
                          isDisabled={isDisabled}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                <section>
                  <div className="my-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                    <ReportsComponent clientId={clientId} clientType={"home-education"} isPage={false} />
                  </div>
                </section>
              </Row>

          }
        </Container>
      </section>
    </>
  );
};

export default ClientHomeDetail;
